import * as $ from 'jquery';
import * as _ from 'lodash';
import { ProgressBar, ProgressBarOptions } from './progressBar';



/** */
export type ProgressTimerOptions = {
    interval?: number
    height?: number
    width?: number
    //direction: 'decrese' | 'increse';
    /**
     * return label Text
     */
    onTick?: (current: number) => number;
    onAt25?: () => void;
    onAt50?: () => void;
    onAt75?: () => void;
    onTimeOut?: () => void;
    /** */
}

/**
 * 
 */
export class ProgressTimer extends ProgressBar {

    private nIntervId;
    private interval: number;
    private limit: number;
    private at: number;
    public onTick: (current: number) => number;
    public onAt25: () => void;
    public onAt50: () => void;
    public onAt75: () => void;
    public onTimeOut: () => void;

    /**
     * 
     * @param selector
     * @param limit
     * @param _options
     */
    constructor(selector: any, limit: number, _options?: ProgressTimerOptions) {
        var options: ProgressBarOptions = {};
        options.max = limit;
        if (!_.isNil(_options?.height)) { options.height = _options.height; }
        if (!_.isNil(_options?.width)) { options.width = _options.width; }

        super(selector, options);
        this.limit = limit;
        //デフォルト1000ミリ秒
        //this.interval = (!_.isNil(_options?.interval)) ? _options.interval : 1000;
        //0はまずいのでfalsyとする
        this.interval = (_options?.interval) ? _options.interval : 1000;

        if (!_.isNil(_options?.onTick)) { this.onTick = _options.onTick; }
        if (!_.isNil(_options?.onAt25)) { this.onAt25 = _options.onAt25; }
        if (!_.isNil(_options?.onAt50)) { this.onAt50 = _options.onAt50; }
        if (!_.isNil(_options?.onAt75)) { this.onAt75 = _options.onAt75; }
        if (!_.isNil(_options?.onTimeOut)) { this.onTimeOut = _options.onTimeOut; }
    }

    /**
     * 
     * @param at 開始
     */
    start(at) {
        this.current = this.at = at;
        this.nIntervId = setInterval(this.tick.bind(this), this.interval);
        return this;
    }

    /** */
    resume() {
        this.stop();
        this.start(this.current);
        return this;
    }

    /** */
    stop() {
        clearInterval(this.nIntervId);
        return this;
    }

    /** */
    private timeOut() {
        this.stop();
        //if (this.showLabel) {
        //    this.labels.text('timeout!!');
        //}
        if (this.onTimeOut) { this.onTimeOut(); }
        return this;
    }

    /**
     * 
     * @param n
     */
    tick() {
        //increase or decrease?
        //var nextTick = this.current - 1;
        //var nextTick = Math.ceil(this.current - (this.interval / 1000));
        var nextTick = Math.floor(this.current - (this.interval / 1000));

        if (this.onTick) {
            //var labelText = this.onTick(nextTick);
            //if (labelText) {
            //    this.setLabelFunc = (c): string => { return labelText; }
            //} else {
            //    this.setLabelFunc = null;
            //}

            var retTick = this.onTick(nextTick);
            if (!_.isNil(retTick)) {
                //補正値があればそれを使用
                nextTick = retTick;
            }

        }

        this.current = nextTick;
        if (this.current <= 0) {
            this.timeOut();
        }
        this.appearance();
        return this;
    }

    /** */
    appearance() {

        this.progressBar.removeClass('bg-danger bg-warning bg-info bg-succsess');
        if (this.parRemaining < 25) { // less than 25 %
            this.progressBar.addClass('progress-bar bg-danger');
            if (this.onAt25) { this.onAt25(); }
        } else if (this.parRemaining < 50) { // less than 50 % (and more than 25 %)
            this.progressBar.addClass('progress-bar bg-warning');
            if (this.onAt50) { this.onAt50(); }
        } else if (this.parRemaining < 75) { // less than 75 % (and more than 50 %)
            this.progressBar.addClass('progress-bar bg-info');
            if (this.onAt75) { this.onAt75(); }
        } else {
            this.progressBar.addClass('progress-bar bg-succsess');
        }
    }




};
